import { Box, Modal, Typography, Button } from "@mui/material";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import EditIcon from "assets/EditIcon.svg";
import dangerIcon from "assets/danger.svg";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A3575",
    color: theme.palette.common.white,
    height: "52px",
    fontSize: "16px",
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "16px",
    height: "100px",
    color: "#191E31",
    fontWeight: 600,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const AccessTable = ({ columns, rows, url }) => {
  const navigate = useNavigate();
  const [openWarning, setOpenWarning] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const filteredColumns = columns.filter(column => {
    if (column.field === 'assignmentStatus') {
      return url === '/editRoleCreation';
    }
    return true;
  });


  const handleWarningClose = () => {
    setOpenWarning(false);
    setSelectedRow(null);
  };

  const handleWarningConfirm = () => {
    setOpenWarning(false);
    navigate('/sr-number-input', { state: { rowData: selectedRow } });
  };

  const handleAssignmentClick = (status, row) => {
    switch (status) {
      case 'Pending':
        break;
      case 'Pending verification from IT Admin':
        navigate('/pending-verification', { state: { rowData: row } });
        break;
      case ('Complete') || ('Completed'):
        navigate(`${url}`, { state: { rowData: row, fromComplete: true } })
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {filteredColumns?.map((column, index) => (
                <StyledTableCell key={index} align={column.align || "left"}>
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns?.map((column, colIndex) => (
                  <StyledTableCell
                    key={colIndex}
                    align={column.align || "left"}
                    width={column.width || ""}
                  >
                    {column.field === "action" ? (
                      <>{((url == '/editAdministratorUserAdd' && row?.isEditableForAdministrator == false)
                      ||(url == '/editadministratorCreation' && row?.isEditableForAdministrator == false)
                      ) ? 
                      <img
                        style={{ cursor: "pointer", opacity:0.3 }}
                        className={row[column.field]}
                        src={EditIcon}
                        alt="Edit"
                      />
                        : <img
                        style={{ cursor: "pointer", opacity: row?.status == "In Active" ? 0.3 : 1 }}
                        className={row[column.field]}
                        onClick={() =>
                          row?.status == "In Active" ? "" : navigate(`${url}`, { state: { rowData: row } })
                        }
                        src={EditIcon}
                        alt="Edit"
                      />}
                      </>
                     
                    )
                      : column.field === "assignmentStatus" && row.assignmentStatus ? (
                        <span
                          style={{
                            cursor: "pointer",
                            textUnderlineOffset: "0.1em",
                            textDecoration: "underline",
                            color: row.assignmentStatus === "Pending" ? "#EF7D00" :
                              row.assignmentStatus === "Pending verification from IT Admin" ? "#0A3575" :
                                "#50AF47"
                          }}
                          onClick={() => handleAssignmentClick(row.assignmentStatus, row)}
                        >
                          {row.assignmentStatus}
                        </span>
                      )
                        : (
                          row[column.field]
                        )}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={openWarning}
        onClose={handleWarningClose}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: { xs: "12rem", md: "17.06rem" },
          justifyContent: "center",
          alignItems: "center",
          padding: 4,
          backgroundColor: 'white',
          borderRadius: "12px"
        }}>
          <img src={dangerIcon} />
          <Typography
            sx={{
              fontSize: "16px",
              color: "#000000",
              textAlign: "center",
              marginTop: "-15px",
              marginBottom: "10px"
            }}
            variant="h8"
          >
            Are You Sure! <br />
            You Want To Send Back To Role Owner?
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              sx={{
                borderRadius: 4,
                minWidth: 90,
                minHeight: 42,
                background: "#737D86",
                marginTop: "13px",
                "&:hover": {
                  backgroundColor: "#737D86",
                },
              }}
              variant="contained"
              type="button"
              onClick={handleWarningClose}
            >
              NO
            </Button>
            <Button
              sx={{
                borderRadius: 4,
                minWidth: 90,
                minHeight: 42,
                background: "#EF7D00",
                marginTop: "13px",
                "&:hover": {
                  backgroundColor: "#EF7D00",
                },
              }}
              variant="contained"
              type="button"
              onClick={handleWarningConfirm}
            >
              YES
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AccessTable;
